import { SegmentEventType } from '../../../../product';

import { SegmentEventFieldsTypes } from '../../../types/zodSchemaTypes';

import { SegmentEventField } from '../SegmentEventField';

export class SegmentEvent {
  eventName: string;
  eventFields: Array<SegmentEventField>;
  segmentEventIntegrationConfig: Record<string, boolean> | undefined;

  constructor(segmentEvent: SegmentEventType) {
    this.eventName = segmentEvent.event_name;
    if (segmentEvent.segment_integration_config_list) {
      this.segmentEventIntegrationConfig = {};
      this.segmentEventIntegrationConfig['All'] = false;
      segmentEvent.segment_integration_config_list?.forEach(
        (eachConfig: string) => {
          if (this.segmentEventIntegrationConfig) {
            this.segmentEventIntegrationConfig[eachConfig] = true;
          }
        }
      );
    }
    this.eventFields = segmentEvent.event_fields.map(
      (eachField: SegmentEventFieldsTypes) => new SegmentEventField(eachField)
    );
  }
}
